// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__sadWU","log":"ModalInventoryLogs_log__2jYcF","date":"ModalInventoryLogs_date__3QEEw","userName":"ModalInventoryLogs_userName__2zY9B"};